module.exports = "@media (max-width: 300px) {\n  ::ng-deep .mat-select-panel .mat-select-content {\n    padding-left: 20px; } }\n"